import WasteFormulaTable from "./table";

const WasteFormula = () => {
  return <WasteFormulaTable />;
};

export default WasteFormula;
